angular.module('wbDashboard').controller('FormulasWalletControllerAurea', 
    ['$scope', '$uibModal', '$filter', '$q', 'FormulaService', 'User', 'Milestone', 'PlanService', 'Message',
function ($scope, $uibModal, $filter, $q, FormulaService, User, Milestone, PlanService, Message) {

    $scope.formulaDefault = { metadata: {}, funding: {}, milestones: [], recommended: {}, extra: { transferEst: 0 }};
    $scope.formula = angular.copy($scope.formulaDefault);

    $scope.$watch('walletMS', function(walletMS) {
        if (walletMS) {
            $scope.formula.funding.auto_deposit = $scope.walletMS.auto_deposit.amount;
        }
    });

    $scope.saveAutoDeposit = function() {
        $scope.pageData.sending = true;

        var msModel, dataMS;

        msModel = Milestone.setMilestoneUpdateFromObject($scope.walletMS);

        msModel.auto_deposit.amount = $scope.formula.funding.auto_deposit;
        if (msModel.accounts.length === 1) { //should always be 1 for wallet
            msModel.accounts[0].auto_deposit = $scope.formula.funding.auto_deposit;
        }
        dataMS = Milestone.prepareSubmitData(msModel);

        Milestone.update(dataMS).then(function() {

            $scope.$state.go("base.receipt", { receipt: {
                    "action": "UPDATE_AUTO",
                    "type": $scope.walletMS.type,
                    "milestone_name": $scope.walletMS.name,
                    "msId": $scope.walletMS.id,
                    "frequency": $scope.autos.frequency,
                    "auto_amount": msModel.auto_deposit.amount,
                    "old_auto_amount": msModel.extra.auto_deposit_original
                }});

            User.retrieveOverview(true);
            User.retrieveMilestones($scope.walletMS.id, true);

            PlanService.user.retrieveAutos();

        }).catch(function() {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.goNextPage = function() {
        if ($scope.$stateParams.page === 'wallet-autos') {
            $scope.goToPage('confirm');
        } else if ($scope.$stateParams.page === 'confirm') {
            $scope.saveAutoDeposit();
        }
    };

    //initial call doesn't need real slug, but endpoint expects the var
    FormulaService.getFormulasAutoRecommend({formulaSlug: 'waahoooo'}).then(function(deposits) {
        $scope.formula.recommended.auto = deposits.auto.total;
        $scope.formula.recommended.one_time = deposits.one_time.total;
    });

    $scope.goToPage = function(page) {
        $scope.$state.go('.', {page: page});
    };
}]);
